
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  ConfirmationDialogComponent,
  ConfirmationDialogProps,
} from 'src/app/shared/components/modals/confirmation-dialog/confirmation-dialog.component';
import { TrackingRegistryResponseDto } from 'src/generated-sources/openapi/wallet-service/tracking-registry';

export interface DeleteDocumentDialogData extends Partial<TrackingRegistryResponseDto> {
  document?: string;
  isAlert30DaysWallet?: boolean;
}

@Component({
    selector: 'app-delete-document-dialog',
    templateUrl: './delete-document-dialog.component.html',
    styleUrls: ['./delete-document-dialog.component.scss'],
    imports: [ConfirmationDialogComponent]
})
export class DeleteDocumentDialogComponent {
  document = '';
  isAlert30DaysWallet = false;

  constructor(
    public dialogRef: MatDialogRef<DeleteDocumentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private readonly data: DeleteDocumentDialogData
  ) {
    this.document = data?.document || '';
    this.isAlert30DaysWallet = data?.isAlert30DaysWallet ?? false;
  }

  get props(): ConfirmationDialogProps {
    return {
      title: $localize`:@@deleteDocumentConfirmationTitle:Eliminación de documento`,
      cancelButton: {
        text: $localize`:@@deleteDocumentBtnCancel:Cancel`,
      },
      confirmButton: {
        text: $localize`:@@deleteDocument:Eliminar documento`,
        style: 'danger',
        icon: 'delete_outlined',
      },
    };
  }

  delete() {
    this.dialogRef.close(true);
  }
}
